const getFirstTouch = (e, touches) => {
  if (touches && touches.length > 0) {
    return touches[0];
  }
  if (e.touches && e.touches.length > 0) {
    return e.touches[0];
  }
  return {};
};
export const eventX = (e, touches) => 'touches' in e ? getFirstTouch(e, touches).clientX || null : e.clientX;
export const eventY = (e, touches) => 'touches' in e ? getFirstTouch(e, touches).clientY || null : e.clientY;
export const prevent = e => {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }
};